<template>
    <div>
        <el-breadcrumb
            v-if="hasRoleToReadLogs"
            style="float: right"
            separator-class="el-icon-arrow-right"
        >
            <el-breadcrumb-item :to="{ path: '/' }">{{$t('route.home')}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{$t('entities.player.plural')}}</el-breadcrumb-item>
        </el-breadcrumb>

        <h2 class="page-title">{{$t('entities.player.plural')}}</h2>

        <el-row :gutter="20">
            <el-col :xs="24" :md="8">
                <el-form @submit.native.prevent class="search" :inline="true">
                    <el-form-item>
                        <el-input v-model="pager.search" :placeholder="$t('table.search')">
                            <el-button slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
            </el-col>

            <el-col class="button-group" :xs="24" :md="16">
                <el-button
                    v-if="hasRoleToCreate"
                    icon="el-icon-fa-file-o"
                    @click="create()"
                    type="primary"
                >{{$t('table.add')}}</el-button>
                <el-button
                    v-if="hasRoleToReadLogs"
                    icon="el-icon-fa-history"
                    @click="history()"
                    type="infor"
                >{{$t('table.history')}}</el-button>
                <el-button
                    v-if="pager.hasDataToExport(list) && hasRoleToReadLogs"
                    @click="pager.exportToCsv(list)"
                    :plain="true"
                    type="success"
                    icon="el-icon-fa-table"
                >{{$t('table.export')}}</el-button>
            </el-col>
        </el-row>
        <el-table
            :data="pager.paginate(list)"
            :default-sort="{
                    prop: 'id',
                    order: 'ascending'
                }"
            @row-click="rowClick"
            empty-text="There are no players yet"
            @sort-change="(args) => pager.sortChange(args)"
            style="width: 100%"
            v-loading="loading"
            border
        >
     
            <!-- <el-table-column
                prop="namePublic"
                :label="$t('entities.player.prop.namePublic')"
                sortable="custom"
            ></el-table-column> -->
            
            <el-table-column prop="name" :label="$t('entities.player.prop.name')" sortable="custom"></el-table-column>

            <el-table-column
                prop="lastName"
                :label="$t('entities.player.prop.lastName')"
                sortable="custom"
            ></el-table-column>

            <el-table-column prop="dni" :label="$t('entities.player.prop.dni')" sortable="custom"></el-table-column>

             <el-table-column
                prop="birthdate"
                :label="$t('entities.player.prop.birthdate')"
                sortable="custom"
            >
                <template slot-scope="scope">{{ getDateFormat(scope.row.birthdate) }}</template>
            </el-table-column>
            
            <el-table-column prop="team" v-if="!teamId"
             :label="$t('entities.team.singular')"
             sortable="custom"
             >
                <template slot-scope="scope">
                    {{ scope.row.team ? scope.row.team.name : ' ' }}
                </template>
            </el-table-column>
            <el-table-column  v-if="!teamId" rop="category" :label="$t('entities.category.singular')" sortable="custom">
                <template slot-scope="scope">{{ scope.row.team ? scope.row.team.category.label : ' ' }}</template>
            </el-table-column>
            <!-- 
            <el-table-column prop="category"
             sortable="custom"
             :label="$t('entities.category.singular')"
             >
                <template slot-scope="scope">
                {{ scope.row.team.category  ?scope.row.team.category : scope.row.team.category.label ? scope.row.team.category.label : ' ' }}
                </template>
            </el-table-column> -->
<!-- 
            <el-table-column
                v-if="hasRoleToReadLogs"
                prop="email"
                :label="$t('entities.player.prop.email')"
                sortable="custom"
            ></el-table-column> -->

            <!-- <el-table-column
                v-if="hasRoleToReadLogs"
                prop="phone"
                :label="$t('entities.player.prop.phone')"
                sortable="custom"
            ></el-table-column> -->

            <el-table-column
                v-if="hasRoleToReadLogs"
                prop="dorsal"
                :label="$t('entities.player.prop.dorsal')"
                sortable="custom"
            ></el-table-column>

            <el-table-column
                v-if="hasRoleToReadLogs"
                prop="position"
                :label="$t('entities.player.prop.position')"
            >
                <template
                    slot-scope="scope"
                >{{ scope.row.position ? scope.row.position.label : '' }}</template>
            </el-table-column>

            <!-- ************************** -->
            <!-- *                        * -->
            <!-- *         Actions        * -->
            <!-- *                        * -->
            <!-- ************************** -->
            <el-table-column
                :fixed="isMobile? undefined : 'right'"
                align="center"
                :label="$t('table.actions')"
                width="120"
            >
                <template slot-scope="scope">
                    <el-tooltip
                        v-if="hasRoleToRead || hasRoleToReadClub"
                        :content="$t('table.details')"
                        placement="top"
                    >
                        <el-button
                            icon="el-icon-fa-search"
                            size="small"
                            type="text"
                            @click="show(scope.row.id)"
                        />
                    </el-tooltip>

                    <el-tooltip v-if="hasRoleToUpdate" :content="$t('table.edit')" placement="top">
                        <el-button
                            icon="el-icon-fa-pencil-square-o"
                            size="small"
                            type="text"
                            @click="edit(scope.row.id)"
                        />
                    </el-tooltip>

                    <el-tooltip
                        v-if="hasRoleToDelete"
                        :content="$t('table.delete')"
                        placement="top"
                    >
                        <el-button
                            icon="el-icon-fa-trash"
                            size="small"
                            type="text"
                            @click="destroy(scope.row)"
                        />
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <div class="mt-3">
            <el-pagination
                style="float: right"
                @size-change="(args) => pager.pageSizeChange(args)"
                :current-page.sync="pager.currentPage"
                :layout="paginationLayout"
                :total="pager.filteredAndSortedList(list).length"
                background
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import UploadExcelComponent from "@/components/UploadExcel";
import { mapGetters } from "vuex";
import moment from "moment"; // birthdate
import Cookies from "js-cookie"; // birthdate

/* eslint-disable */

export default {
    name: "app-player-list",
    components: { UploadExcelComponent },

    props: {
        teamId: String
    },
    data() {
        return {
            tableData: [],
            tableHeader: []
        };
    },
    computed: {
        ...mapGetters({
            loading: "entities/player/loading",
            list: "entities/player/list",
            pager: "entities/player/pager",
            hasRoleToCreate: "entities/player/hasRoleToCreate",
            hasRoleToRead: "entities/player/hasRoleToRead",
            hasRoleToUpdate: "entities/player/hasRoleToUpdate",
            hasRoleToDelete: "entities/player/hasRoleToDelete",
            hasRoleToReadClub: "entities/club/hasRoleToRead",
            hasRoleToReadLogs: "entities/player/hasRoleToReadLogs",
            isMobile: "shared/isMobile",
            paginationLayout: "shared/paginationLayout"
        })
    },

    created() {
        if (this.teamId) {
            this.$store.dispatch("entities/player/listByTeamId", this.teamId);
        } else {
            this.$store.dispatch("entities/player/list");
        }
    },

    beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/player/clear");
        next();
    },

    beforeRouteUpdate(to, from, next) {
        this.$store.dispatch("entities/player/list");
        next();
    },

    methods: {
        create() {
            this.$router.push({
                name: "playerNew"
            });
        },

        rowClick(row, column, cell, event) {
            if (cell.label != this.$t("table.actions")) {
                this.$router.push({
                    name: "playerShow",
                    params: { id: row.id }
                });
            }
        },

        show(id) {
            this.$router.push({
                name: "playerShow",
                params: { id }
            });
        },

        edit(id) {
            this.$router.push({
                name: "playerEdit",
                params: { id }
            });
        },

        destroy(model) {
            this.$confirm(
                this.$t("table.areYouSure"),
                this.$t("table.confirm"),
                {
                    confirmButtonText: this.$t("table.yes"),
                    cancelButtonText: this.$t("table.no"),
                    type: "warning"
                }
            )
                .then(() =>
                    this.$store.dispatch("entities/player/destroy", model)
                )
                .then(() => {
                    if (this.teamId) {
                        this.$store.dispatch(
                            "entities/player/listByTeamId",
                            this.teamId
                        );
                    } else {
                        this.$store.dispatch("entities/player/list");
                    }
                })
                .catch(() => {});
        },

        history() {
            this.$router.push({ name: "playerHistoryFull" });
        },

        // Functions upload excel
        beforeUpload(file) {
            const isLt1M = file.size / 1024 / 1024 < 1;

            if (isLt1M) {
                return true;
            }

            this.$message({
                message: "Please do not upload files larger than 1m in size.",
                type: "warning"
            });
            return false;
        },
        handleSuccess({ results, header }) {
            this.tableData = results;
            this.tableHeader = header;
        },
        // Aux functions
        getDateFormat(dateString) {
            console.log("<---- GET DATE FORMAT");
            console.log(dateString);
            console.log(new Date(dateString));

            return moment(dateString, ["YYYY-MM-DD"])
                .locale(Cookies.get("language") || "es")
                .format("L");
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/entities/player/player-list.vue?0c9bc2e2